import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a08e28cf6558f0014cce796/nhl_analytics_pro/src/app/knowledge-graph/components/KnowledgeGraphClient.tsx");
